<div class="d-flex justify-content-between align-items-center">
    <h1 class="title-potential-dealers">Potenciais compradores</h1>
    <i class="material-icons close-icon cursor-pointer close-button" (click)="close()">close</i>
</div>

<div class="vehicle-info mb-4">
    {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.trim }} {{ vehicle.modelYear }}/{{ vehicle.manufactureYear }}
</div>

<div class="interested-dealers-container mb-5">
    <div class="interested-title">INDICADORES DE INTERESSE</div>
    <div class="interested-content px-3 mt-4">
        <div class="interested-content-item">
            <img src="assets/images/icons/icon-group.svg">
            <div class="d-flex flex-column justify-content-center">
                <div class="interested-content-item-title">
                    Total interessados
                </div>
                <div class="interested-content-item-value">
                    {{ totalInterested }} Lojistas
                </div>
            </div>
        </div>
        <div class="interested-content-item">
            <img src="assets/images/icons/icon-afinidade.svg">
            <div class="d-flex flex-column justify-content-center">
                <div class="interested-content-item-title">
                    Afinidade média
                </div>
                <div class="interested-content-item-value">
                    {{ averageAffinityLabel }} ({{ averageAffinityPercent | number:'1.0-0' }}%)
                </div>
            </div>
        </div>
        <div class="interested-content-item">
            <img src="assets/images/icons/fipe-icon.svg">
            <div class="d-flex flex-column justify-content-center">
                <div class="interested-content-item-title">
                    Tabela fipe
                </div>
                <div class="interested-content-item-value">
                    R$ {{ fipePrice | number:'1.0-0' }}
                </div>
            </div>
        </div>
    </div>
</div>

<form class="filters-container mb-4" [formGroup]="filtersForm">
    <div class="filters-content row align-items-end">
        <mat-form-field class="col-3">
            <mat-label>Região</mat-label>
            <mat-select formControlName="region">
                <mat-option *ngFor="let region of regions" [value]="region.value">{{ region.label }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col-3">
            <mat-label>Similaridade do modelo</mat-label>
            <mat-select formControlName="modelFilter">
                <mat-option *ngFor="let modelFilter of modelFilters" [value]="modelFilter.value">{{ modelFilter.label
                    }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col-3">
            <mat-label>Base para comparação</mat-label>
            <mat-select formControlName="onlyBoughtFromSeller">
                <mat-option [value]="false">Todos os compradores</mat-option>
                <mat-option [value]="true">Apenas compradores que já compraram do vendedor</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col-3">
            <mat-label>Período</mat-label>
            <mat-select formControlName="periodDays">
                <mat-option *ngFor="let days of periodDaysOptions" [value]="days">Últimos {{ days }} dias</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</form>

<div class="table-container">
    <div *ngIf="isLoading" class="text-center py-3">
        <app-loader [loading]="true" [small]="true"></app-loader>
    </div>
  <div *ngIf="!isLoading && buyers?.length === 0" class="empty-state">
      <img src="assets/icon-font/car-alt.svg" alt="Nenhum lojista encontrado">
      <div class="empty-text">Não encontramos lojistas com os filtros atuais.</div>
      <div class="empty-text">Tente ampliar a região ou mudar o período.</div>
  </div>
    <table class="w-100" *ngIf="buyers?.length">
        <thead>
            <tr>
                <th>Perfil</th>
                <th>Contato</th>
                <th style="width: 175px;">Contexto</th>
                <th>Afinidade</th>
                <th style="width: 120px;">Último acesso</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let buyer of buyers; trackBy: trackBuyer">
                <td>
                    <div class="dealer-info-col">
                        <div class="dealer-name">{{ buyer.name }}</div>
                        <div class="dealer-cnpj" *ngIf="buyer.cpfCnpj">
                            <div class="d-flex align-items-center" style="gap: 2px;">
                                <i class="material-icons" style="font-size: 20px;">business</i>
                                {{ buyer.cpfCnpj }}
                            </div>
                        </div>
                        <div class="dealer-location" *ngIf="buyer.city || buyer.uf">
                            <div class="d-flex align-items-center" style="gap: 4px;">
                                <i class="material-icons" style="font-size: 20px;">location_on</i>
                                {{ buyer.city }} / {{ buyer.uf }}
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="dealer-info-col align-items-center">
                        <div class="dealer-whatsapp" *ngIf="buyer.whatsappNumber">
                            <div class="d-flex align-items-center cursor-pointer" style="gap: 4px;" (click)="openWhatsapp(buyer.whatsappNumber)">
                                <i class="mdi mdi-whatsapp icon-footer" style="font-size: 20px;"></i>
                                {{ buyer.whatsappNumber }}
                            </div>
                        </div>
                        <div class="dealer-phone" *ngFor="let phone of (buyer.phoneNumbers || [])">
                            <div class="d-flex align-items-center" style="gap: 4px;">
                                <i class="material-icons" style="font-size: 20px;">call</i>
                                {{ phone }}
                            </div>
                        </div>
                        <div class="dealer-email" *ngIf="buyer.email">
                            <div class="d-flex align-items-center" style="gap: 4px;">
                                <i class="material-icons" style="font-size: 20px;">email</i>
                                {{ buyer.email }}
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="dealer-info-col align-items-center">
                        <div [ngClass]="getContextTag(buyer.contextTag)?.class || ''">
                            <div class="d-flex align-items-center" style="gap: 6px; font-size: 12px;">
                                <i class="material-icons check-circle" style="font-size: 20px;" *ngIf="buyer.contextTag === 'BOUGHT_FROM_YOU'">check_circle</i>
                                {{ getContextTag(buyer.contextTag)?.label || '—' }}
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="dealer-info-col align-items-center">
                        <ng-container *ngIf="getAffinityPercent(buyer) as affinity">
                            <div class="affinity-progress" [ngClass]="[getAffinityRangeClass(buyer), affinity <= 0 ? 'is-empty' : '']">
                                <div class="affinity-progress-fill" [style.width.%]="affinity"></div>
                                <span class="affinity-progress-text" [ngStyle]="{color: affinity < 50 ? '#000' : '#fff'}">
                                    {{ formatPercentage(affinity) }}%
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </td>
                <td>
                    <div class="dealer-info-col align-items-center">
                        <div class="last-access">
                            <div class="d-flex align-items-center">
                                {{ buyer.lastAccessAt ? (buyer.lastAccessAt | date:'dd/MM/yyyy HH:mm') : '—' }}
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>